import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import {PowerSupplyContext} from '../../../../..';

import './style.scss';

export function Screen(props) {
  const {power} = React.useContext(PowerSupplyContext);

  const [hover, setHover] = React.useState(false);
  const [focus, setFocus] = React.useState(false);

  const onMouseEnter = () => {
    !focus && setHover(true);
  };
  const onMouseLeave = () => {
    !focus && setHover(false);
  };

  const onFocus = () => {
    setFocus(true);
    setHover(true);
  };

  const onBlur = () => {
    setFocus(false);
    setHover(false);
  };

  const [height, setHeight] = React.useState(0);
  const [width, setWidth] = React.useState(0);
  const onImageLoad = (event) => {
    const {offsetHeight, offsetWidth} = event.target;
    setHeight(offsetHeight);
    setWidth(offsetWidth);
  };

  const renderHoverOverlay = () => (
    <div
      className='ps_screen_overlay__hover'
      style={{height: height, width: width}}
    />
  );
  const renderFocusOverlay = () => (
    <div
      className='ps_screen_overlay__focus'
      style={{height: height - 4, width: width - 4}}
    />
  );

  return (
    <div
      className={`ps_screen ${props.className}`}
      tabIndex={0}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      aria-label={props.ariaLabel}
      >
      {power && hover && renderHoverOverlay()}
      {power && focus && renderFocusOverlay()}
      <Image
        onLoad={onImageLoad}
        className={'ps_screen_image'}
        src={props.imageSrc}
      />
      {power && props.children}
    </div>
  );
}

Screen.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components passed to screen
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  /**
   * image src for screen background
   */
  imageSrc: PropTypes.string,
};

Screen.defaultProps = {
  className: '',
};
